export default {
  SET_STOCK_ORDER_LIST(state, res) {
    state.stockOrderList = res.items;
    state.totalDataRow = res.totalCount;
  },
  SET_EMPTY_STOCK_ORDER(state, res) {
    state.emptyStockOrder = res;
  },
  APPROVE_STOCK_ORDER(state, stockOrder) {
    let order = state.stockOrderList.find(x => x.id = stockOrder.id);
    Object.assign(order, stockOrder);
  },
  SAVE_STOCK_ORDER(state, stockOrder) {
    let order = state.stockOrderList.find(x => x.id = stockOrder.id);
    if (order) {
      Object.assign(order, stockOrder);
    } else {
      state.stockOrderList.unshift(stockOrder);
      state.totalDataRow++;
    }
  },
  CANCELED_STOCK_ORDER(state, stockOrder) {
    let order = state.stockOrderList.find(x => x.id === stockOrder.id);
    Object.assign(order, stockOrder);
  },
  CHANGE_STATE_STOCK_ORDER(state, stockOrder) {
    let order = state.stockOrderList.find(x => x.id = stockOrder.id);
    Object.assign(order, stockOrder);
  },
  PREPARING_STOCK_ORDER(state, stockOrder) {
    let order = state.stockOrderList.find(x => x.id = stockOrder.id);
    Object.assign(order, stockOrder);
  }
}
